// Microsoft 4-square brand logo. Inlined as an SVG so consumers don't pull in
// a separate asset just to render the wordmark on a button.
const MicrosoftLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 23 23" aria-hidden="true">
    <path d="M0 0h11v11H0z" fill="#F25022" />
    <path d="M12 0h11v11H12z" fill="#7FBA00" />
    <path d="M0 12h11v11H0z" fill="#00A4EF" />
    <path d="M12 12h11v11H12z" fill="#FFB900" />
  </svg>
);

export default MicrosoftLogo;
